import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Settings } from 'common/core/config/settings.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { icons } from './icons';
import { faUserLock, faShippingFast, faDollarSign, faDownload, faTrafficLight, faShareAlt, faSave, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
var HomepageComponent = /** @class */ (function () {
    function HomepageComponent(settings, changeDetection, library) {
        var _a;
        this.settings = settings;
        this.changeDetection = changeDetection;
        this.library = library;
        /**@ViewChild('totalDownloads', { static: false }) totalDownloads: ElementRef
        @ViewChild('totalTraffic', { static: false }) totalTraffic: ElementRef*/
        this.faUserLock = faUserLock;
        this.faShippingFast = faShippingFast;
        this.faDollarSign = faDollarSign;
        this.faDownload = faDownload;
        this.faTrafficLight = faTrafficLight;
        this.faShareAlt = faShareAlt;
        this.faSave = faSave;
        this.faCloudUploadAlt = faCloudUploadAlt;
        (_a = this.library).addIcons.apply(_a, icons);
    }
    HomepageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.settings.onChange.subscribe(function () {
            _this.changeDetection.detectChanges();
        });
        VANTA.GLOBE({
            el: ".bg-container",
            mouseControls: true,
            touchControls: true,
            minHeight: 200.00,
            minWidth: 200.00,
            scale: 1.00,
            scaleMobile: 1.00,
            color: 0xff6435,
            backgroundColor: 0x161921,
            size: 0.9
        });
    };
    HomepageComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    /**@HostListener('window:scroll', ['$event'])
    onScroll(event) {
        if (window.scrollY >= this.totalDownloads.nativeElement.getBoundingClientRect().top + this.totalDownloads.nativeElement.scrollHeight) {
            this.animateCount(this.totalDownloads, 999)
            this.animateCount(this.totalTraffic, 999, 'TB')
        }
    }**/
    HomepageComponent.prototype.backgroundStyle = function () {
        var base = 'url(', end = ')', url = this.settings.get('landingPage.background');
        return base + this.settings.getBaseUrl(true) + url + end;
    };
    return HomepageComponent;
}());
export { HomepageComponent };
